// extracted by mini-css-extract-plugin
module.exports = {"extraDataInputs":"extraDataInputs__Zryrs","input":"input__+QMdy","label":"label__z-cCf","documentPreviewMode":"documentPreviewMode__Hn+Kq"};